import { Checkbox, ListItemText } from '@mui/material';

import { StyledSelectedListItem, StyledUnselectedListItem } from './BrandOrderListItem.styles';
import { BrandOrderListItemProps } from './BrandOrderListItem.types';
import { ListItemSecondaryAction } from '../ListItemSecondaryAction';

export const BrandOrderListItem = ({
  type,
  isMobile,
  brandId,
  brandName,
  checked,
  isDragging,
  isVisible,
  isOkko,
  originalIndex,
  localOrder = [],
  onDragEnd,
  onDragStart,
  onDrop,
  onDragOver,
  onBrandToggle,
  moveDown,
  moveUp
}: BrandOrderListItemProps) => {
  const handleBrandToggle = () => {
    if (!onBrandToggle) return;
    onBrandToggle(brandId);
  };
  const handleDragStart = (e: React.DragEvent) => {
    if (!onDragStart || typeof originalIndex === 'undefined') return;
    onDragStart(e, originalIndex);
  };

  const handleDragOver = (e: React.DragEvent) => {
    if (!onDragOver || typeof originalIndex === 'undefined') return;
    onDragOver(e, originalIndex);
  };

  if (type === 'unselected') {
    return (
      <StyledUnselectedListItem key={`${brandId}_${brandName}`} isMobile={isMobile}>
        <Checkbox checked={checked} onChange={handleBrandToggle} sx={{ ...(isMobile && { p: 1.5 }) }} />
        <ListItemText
          primary={brandName}
          secondary="Не відображається"
          primaryTypographyProps={{
            fontSize: isMobile ? '1rem' : '0.875rem'
          }}
          secondaryTypographyProps={{
            fontSize: isMobile ? '0.85rem' : '0.75rem'
          }}
        />
      </StyledUnselectedListItem>
    );
  }

  return (
    <StyledSelectedListItem
      draggable={isVisible && !isOkko}
      isDragging={isDragging}
      isVisible={isVisible}
      isOkko={isOkko}
      isMobile={isMobile}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
      onDragStart={handleDragStart}
      onDragOver={handleDragOver}
    >
      <Checkbox checked={checked} disabled={isOkko} onChange={handleBrandToggle} sx={{ ...(isMobile && { p: 1.5 }) }} />
      <ListItemText
        primary={brandName}
        secondary={isOkko ? 'Завжди відображається' : undefined}
        primaryTypographyProps={{
          fontSize: isMobile ? '1rem' : '0.875rem',
          fontWeight: isVisible ? 500 : 400
        }}
        secondaryTypographyProps={{
          fontSize: isMobile ? '0.85rem' : '0.75rem'
        }}
      />
      <ListItemSecondaryAction
        isMobile={isMobile}
        isVisible={isVisible}
        isOkko={isOkko}
        isDragging={isDragging}
        localOrder={localOrder}
        brandId={brandId}
        moveDown={moveDown}
        moveUp={moveUp}
      />
    </StyledSelectedListItem>
  );
};
